import React from 'react';
import styled from 'styled-components';
import { getPlayerAvatarUrl } from '../utils/assetUrls';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
`;

const Avatar = styled.img`
  width: ${(props) => props.$size ?? 28}px;
  height: ${(props) => props.$size ?? 28}px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: ${(props) => props.theme?.secondaryBg ?? '#eee'};
`;

const Name = styled.span`
  font-weight: 600;
`;

/**
 * Renders a player name with optional headshot when playerId is available.
 * @param {Object} props
 * @param {number|string} [props.playerId] - MLB player ID for avatar
 * @param {string} props.playerName - Display name
 * @param {number} [props.size] - Avatar size in px (default 28)
 * @param {boolean} [props.showName=true] - When false, only the avatar is rendered (for use when name is shown elsewhere)
 */
function PlayerWithAvatar({ playerId, playerName, size = 28, showName = true }) {
  const avatarUrl = getPlayerAvatarUrl(playerId);
  return (
    <Wrapper>
      {avatarUrl && (
        <Avatar
          src={avatarUrl}
          alt=""
          $size={size}
          loading="lazy"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      )}
      {showName && <Name>{playerName ?? '—'}</Name>}
    </Wrapper>
  );
}

export default PlayerWithAvatar;
